import { CommonSurgery, Surgery } from '~/storm'
import { getMainSurgeon, isUnScheduledSurgery } from '~/utils/dips'
import { isNullish } from '~/utils/guards'
import { getSurgeryMetadata } from '~/utils/surgeryMetadata'

export function mainSurgeon<T extends Surgery>(practitionerValues: string[]) {
    return (item: T) => {
        // Include item if no practitioners are specified
        if (!practitionerValues.length) return true

        // Include item only if the main surgeon is in the list
        const mainSurgeonShortName = getMainSurgeon(item.surgeryResources)?.shortName
        return mainSurgeonShortName ? practitionerValues.includes(mainSurgeonShortName) : false
    }
}

export function cleared(clearedValues: string[]) {
    return (item: CommonSurgery) => {
        const isPatientCleared = getSurgeryMetadata(item)?.patient_ready
        const isUnscheduledSurgery = isUnScheduledSurgery(item)

        return (
            clearedValues.length === 0 ||
            (clearedValues.includes('new') && (isUnscheduledSurgery ? isNullish(isPatientCleared) : false)) ||
            (clearedValues.includes('notCleared') && (isUnscheduledSurgery ? isPatientCleared === false : !isPatientCleared)) ||
            (clearedValues.includes('cleared') && isPatientCleared === true)
        )
    }
}
